export default {"src":"/_next/static/media/locationGrey.ba8b4d74.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};